import scrollIntoView from 'scroll-into-view-if-needed';
export function scrollIntoViewIfNeeded(element) {
  scrollIntoView(element, {
    scrollMode: 'if-needed',
    behavior: 'auto',
    block: 'end',
    inline: 'nearest'
  });
}
//# sourceMappingURL=scrollIntoViewIfNeeded.js.map